import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { TGetWeighScale } from "@/interfaces/wastetype.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const weighScaleApi = createApi({
  reducerPath: "weighScaleApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["weighScale", "single-weighScale"],
  endpoints: (builder) => ({
    addWeighScaleTicket: builder.mutation<object, unknown>({
      query: ({ data }) => ({
        url: `/workspace/${getWorkspace()}/waste-management/weighscale`,
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      invalidatesTags: ["weighScale"],
    }),

    updateWeightScaleTicket: builder.mutation<
      object,
      { id: string; data: object }
    >({
      query: ({ id, data }) => ({
        url: `/workspace/${getWorkspace()}/waste-management/weighscale/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["weighScale", "single-weighScale"],
    }),

    getWeighScaleTicket: builder.query<
      GeneralResponse<TGetWeighScale[]>,
      string
    >({
      query: (filters) =>
        `/workspace/${getWorkspace()}/waste-management/weighscale${filters ? filters : ""}`,
      providesTags: ["weighScale"],
    }),

    getSingleWeighScaleTicket: builder.query<TGetWeighScale, string>({
      query: (id) =>
        `/workspace/${getWorkspace()}/waste-management/weighscale/${id}`,
      providesTags: ["single-weighScale"],
      transformResponse: (response: APIResponse<TGetWeighScale>) =>
        response?.data,
    }),

    alterWeighScaleStatus: builder.mutation<
      object,
      { id: string; status: string }
    >({
      query: ({ id, status }) => ({
        url: `/workspace/${getWorkspace()}/waste-management/weighscale/${id}/${status}`,
        method: "PATCH",
      }),
      invalidatesTags: ["weighScale", "single-weighScale"],
    }),
  }),
});

export const {
  useAddWeighScaleTicketMutation,
  useUpdateWeightScaleTicketMutation,
  useGetWeighScaleTicketQuery,
  useGetSingleWeighScaleTicketQuery,
  useAlterWeighScaleStatusMutation,
} = weighScaleApi;
